module.exports = __webpack_public_path__ + "img/pdf.4f67b8f0.jpg";